const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5203/api";

export default API_URL;
